
import {ViewOrderContext} from "./ViewOrderContext";
import {useState, useRef} from "react";
import {getFirestoreRef} from "../../core/database/firebase";
import {collection, doc, getDoc, getDocs} from "firebase/firestore";
import {IOrderBasketItem} from "../../core/interfaces/IOrderInfo";
import {IFinalOrder} from "../../core/interfaces/dto/IFinalOrder";



export const ViewOrderProvider = (props: any) =>
{
    const orderParentName = "orderCollection";
    const courseOrderCollectionName = "orders";
    const orderBasketItemsCollectionName = "basketItems";

    const orderId = '';
    const courseId = '';

    const [pageInfo, setPageInfo] = useState({
        pageLoading: true,
        order: null as (IFinalOrder | null),
        basketItems: [] as IOrderBasketItem[],
        error: null as string | null
    })

    const requestIdRef = useRef(0);

    const getOrderInfoFromFirebase = async (courseId: string, orderId: string) =>
    {
        const requestId = ++requestIdRef.current;
        setPageInfo({pageLoading: true, order: null, basketItems: [], error: null});
        const fire = getFirestoreRef();
        const ref = doc(fire, orderParentName, courseId, courseOrderCollectionName, orderId);

        let basketItems: IOrderBasketItem[] = [];
        let orderInfo: IFinalOrder | null = null;
        let loadingError = null;
        try
        {
            const orderDoc = await getDoc(ref);
            if (!orderDoc.exists()) {
                if (requestId === requestIdRef.current) {
                    setPageInfo({pageLoading: false, order: null, basketItems: [], error: 'This order could not be found.'});
                }
                return;
            }
            orderInfo = orderDoc.data() as IFinalOrder;

            const basketRef = collection(fire, orderParentName, courseId, courseOrderCollectionName, orderId, orderBasketItemsCollectionName);
            const basketSnapshot = await getDocs(basketRef);

            basketSnapshot.forEach(doc =>
            {
                const basketItem = doc.data() as IOrderBasketItem
                basketItems.push(basketItem);
            });
        }
        catch(error)
        {
            loadingError = 'Error loading order information, please refresh to try again';
        }

        if (requestId !== requestIdRef.current) return;
        setPageInfo({
            pageLoading: false,
            order: orderInfo,
            error: loadingError,
            basketItems: basketItems
        });
    }

    const provider =
        {
            orderId,
            courseId,
            pageInfo,

            getOrderInfoFromFirebase
        }

    return (
        <ViewOrderContext.Provider value={provider}>
            {props.children}
        </ViewOrderContext.Provider>
    )

}
